import { render, staticRenderFns } from "./SocialLookupField.vue?vue&type=template&id=045a4ac5&"
import script from "./SocialLookupField.vue?vue&type=script&lang=js&"
export * from "./SocialLookupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports